export const PALETTE: readonly string[] = [
  '#63b3ed',
  '#48bb78',
  '#a78bfa',
  '#f6ad55',
  '#f56565',
  '#38b2ac',
  '#ed64a6',
  '#ecc94b',
  '#9f7aea',
  '#4fd1c5',
] as const;

function hash32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

export function colorForClaim(claimId: string): string {
  return PALETTE[hash32(claimId) % PALETTE.length];
}
